// extracted by mini-css-extract-plugin
export default {"Container":"_Container--CvKGI","Collapsed":"_Collapsed--Rt9Ln"};